import { render, staticRenderFns } from "./MfaSetup.vue?vue&type=template&id=6fa45855&scoped=true&"
import script from "./MfaSetup.vue?vue&type=script&lang=js&"
export * from "./MfaSetup.vue?vue&type=script&lang=js&"
import style0 from "./MfaSetup.vue?vue&type=style&index=0&id=6fa45855&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa45855",
  null
  
)

export default component.exports